import AccordionItem from '@atoms/AccordionItem/AccordionItem';
import LoadingSpinner from '@atoms/LoadingSpinner/LoadingSpinner';
import Components from '@dotnet-index'; // Imports the components from the application outside the shared libraries dotnet index
import { IContentExpander } from '@models/IContentExpander';
import SizeEnum from '@models/enums/SizeEnum';
import ThemeEnum from '@models/enums/ThemeEnum';
import Accordion from '@molecules/Accordion/Accordion';
import classNames from 'classnames';
import { ComponentType, Suspense } from 'react';

type ComponentKeys = keyof typeof Components;

const ContentExpander = ({ items }: IContentExpander) => {
  const loadComponent = (name: ComponentKeys): ComponentType<any> | null => {
    const Component = Components[name];
    if (!Component) {
      console.error(`Component ${name} not found in the components index`);
      return null;
    }
    return Component;
  };

  return (
    <section className="tw-container tw-w-full">
      <Accordion>
        {items.map(({ title, content }, index) => {
          const Component = loadComponent(
            content?.componentName as ComponentKeys
          );

          return (
            <div key={title} id={`a-${content.anchorId}`} className="anchor">
              <AccordionItem
                animateChildren
                title={title}
                isOpen={index === 0}
                buttonClasses={classNames(
                  {
                    'tw-border-t tw-border-grey-20': index === 0,
                  },
                  '[&_section]:tw-!p-0'
                )}
                variant="contentExpander"
              >
                <Suspense
                  fallback={
                    <div className="tw-flex tw-h-2xl tw-items-center tw-justify-center">
                      <LoadingSpinner
                        size={SizeEnum.Large}
                        loadingLabel="loading"
                        theme={ThemeEnum.Dark}
                      />
                    </div>
                  }
                >
                  {Component && <Component {...content} {...content.items} />}
                </Suspense>
              </AccordionItem>
            </div>
          );
        })}
      </Accordion>
    </section>
  );
};

export default ContentExpander;
